// STATUS: draft — needs native-speaker check before live
// Welsh visitor messages (task TR1, docs/modules/languages.md s2). Standard Welsh, polite "chi". Visitor keys only; missing keys fall back to en-GB.
export const cyVisitor = {
    'kiosk.pairing.title': 'Gosod y ciosg hwn',
    'kiosk.pairing.hint': 'Rhowch y cod o borth CloudSign.',
    'kiosk.pairing.go': 'Paru',
    'kiosk.pairing.codeLabel': 'Cod paru',
    'kiosk.pairing.checking': 'Yn gwirio’r cod…',
    'kiosk.pairing.clear': 'Clirio',
    'kiosk.pairing.back': 'Dileu’r digid olaf',
    'kiosk.pairing.invalid': 'Nid yw’r cod hwn yn ddilys neu mae wedi dod i ben. Gofynnwch am un newydd.',
    'kiosk.pairing.noNetwork': 'Methu â chyrraedd CloudSign. Gwiriwch y Wi-Fi a rhowch gynnig arall arni.',
    'kiosk.common.back': 'Yn ôl',
    'kiosk.common.next': 'Nesaf',
    'kiosk.common.continue': 'Parhau',
    'kiosk.common.cancel': 'Canslo',
    'kiosk.common.yes': 'Ie',
    'kiosk.common.no': 'Na',
    'kiosk.welcome.tap': 'Tapiwch yma i gofrestru neu adael',
    'kiosk.welcome.offline': 'All-lein: cedwir cofrestriadau ac anfonir yn nes ymlaen',
    'kiosk.home.title': 'Beth hoffech chi ei wneud?',
    'kiosk.home.signIn': 'Cofrestru fy mynediad',
    'kiosk.home.signOut': 'Cofrestru fy ymadawiad',
    'kiosk.home.scan': 'Sganio fy mathodyn',
    'kiosk.groups.titleIn': 'Pwy ydych chi’n cofrestru fel?',
    'kiosk.groups.titleOut': 'Pwy ydych chi’n cofrestru eich ymadawiad fel?',
    'kiosk.groups.hint': 'Dewiswch yr un sy’n addas i chi orau.',
    'kiosk.groups.repeat': 'Aelodau rheolaidd',
    'kiosk.pin.hint': 'Rhowch eich PIN 4 digid.',
    'kiosk.pin.entered': '{count} o 4 digid wedi’u rhoi',
    'kiosk.pin.wrong': 'Nid yw’r PIN hwnnw’n gywir. Rhowch gynnig arall arni.',
    'kiosk.pin.locked': 'Gormod o PINau anghywir. Mae rhoi PIN wedi’i gloi am rai munudau. Gofynnwch i rywun am help.',
    'kiosk.pin.clear': 'Clirio',
    'kiosk.pin.back': 'Dileu’r digid olaf',
    'kiosk.identify.title': 'Dewch o hyd i’ch enw',
    'kiosk.identify.placeholder': 'Dechreuwch deipio’ch enw',
    'kiosk.identify.none': 'Ni chafwyd neb o’r enw hwnnw.',
    'kiosk.identify.addSelf': 'Nid wyf ar y rhestr',
    'kiosk.addSelf.title': 'Ychwanegwch eich hun',
    'kiosk.name.title': 'Beth yw eich enw?',
    'kiosk.name.label': 'Eich enw',
    'kiosk.name.fullNameHint': 'Rhowch eich enw cyntaf a’ch cyfenw.',
    'kiosk.already.message': 'Rydych eisoes wedi cofrestru’ch mynediad. Hoffech chi gofrestru’ch ymadawiad yn lle hynny?',
    'kiosk.already.signOut': 'Cofrestrwch fy ymadawiad',
    'kiosk.questions.titleIn': 'Ychydig o gwestiynau cyflym',
    'kiosk.questions.titleOut': 'Cyn i chi fynd',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Rwy’n deall',
    'kiosk.questions.hostSearch': 'Teipiwch enw’r person rydych yn ymweld ag ef',
    'kiosk.questions.changeHost': 'Newid',
    'kiosk.notices.progress': 'Hysbysiad {n} o {total}',
    'kiosk.notices.accept': 'Rwyf wedi darllen hwn ac rwy’n cytuno',
    'kiosk.notices.sign': 'Llofnodi',
    'kiosk.notices.signHere': 'Llofnodwch gyda’ch bys, os gwelwch yn dda.',
    'kiosk.signature.pad': 'Blwch llofnod',
    'kiosk.signature.clear': 'Clirio’r llofnod',
    'kiosk.signature.captured': 'Llofnod wedi’i gadw',
    'kiosk.photo.title': 'Llun',
    'kiosk.photo.hint': 'Edrychwch ar y camera a thapiwch y botwm.',
    'kiosk.photo.take': 'Tynnu fy llun',
    'kiosk.photo.getReady': 'Paratowch…',
    'kiosk.photo.retake': 'Tynnu eto',
    'kiosk.photo.use': 'Defnyddio’r llun hwn',
    'kiosk.photo.skip': 'Hepgor y llun',
    'kiosk.photo.failed': 'Ni weithiodd y llun. Rhowch gynnig arall arni.',
    'kiosk.photo.noCamera': 'Nid yw’r camera ar gael. Gallwch barhau heb lun.',
    'kiosk.photo.privacy': 'Dim ond ar gyfer eich bathodyn a’ch cofnod ymweliad y defnyddir eich llun.',
    'kiosk.badge.title': 'Eich bathodyn',
    'kiosk.badge.ask': 'Hoffech chi fathodyn?',
    'kiosk.badge.yes': 'Argraffu fy mathodyn',
    'kiosk.badge.no': 'Na, diolch, dim bathodyn',
    'kiosk.badge.printing': 'Yn argraffu eich bathodyn…',
    'kiosk.badge.done': 'Cymerwch eich bathodyn, os gwelwch yn dda',
    'kiosk.badge.failed': 'Mae’n ddrwg gennym, ni argraffwyd y bathodyn. Rydych wedi cofrestru. Gofynnwch am fathodyn yn y dderbynfa.',
    'kiosk.signout.title': 'Dewch o hyd i’ch enw i adael',
    'kiosk.signout.search': 'Chwilio yn ôl enw',
    'kiosk.signout.hiddenHint': 'Er preifatrwydd, ni restrir enwau. Teipiwch eich enw neu sganiwch eich bathodyn.',
    'kiosk.signout.empty': 'Does neb wedi cofrestru.',
    'kiosk.signout.noMatch': 'Ni chafwyd neb. Rhowch gynnig arall arni neu sganiwch eich bathodyn.',
    'kiosk.signout.unnamed': 'Ymwelydd',
    'kiosk.scan.title': 'Sganiwch eich bathodyn',
    'kiosk.scan.hint': 'Daliwch god QR eich bathodyn o flaen y camera.',
    'kiosk.scan.allow': 'Caniatáu’r camera',
    'kiosk.scan.noCamera': 'Nid yw’r camera ar gael. Dewiswch eich enw o’r rhestr, os gwelwch yn dda.',
    'kiosk.scan.notBadge': 'Nid bathodyn CloudSign yw hwnnw. Rhowch gynnig arall arni.',
    'kiosk.scan.notSignedIn': 'Nid yw’r bathodyn hwnnw wedi cofrestru yma. Dewiswch eich enw o’r rhestr.',
    'kiosk.finish.inTitle': 'Diolch, {name}',
    'kiosk.finish.inMessage': 'Rydych wedi cofrestru.',
    'kiosk.finish.outTitle': 'Hwyl, {name}',
    'kiosk.finish.outMessage': 'Rydych wedi cofrestru’ch ymadawiad. Taith ddiogel!',
    'kiosk.finish.tap': 'Tapiwch i orffen',
    'kiosk.update.title': 'Mae angen diweddariad ar y ciosg hwn',
    'kiosk.update.message': 'Mae angen diweddaru’r ciosg cyn y gall eich cofrestru yma. Gofynnwch yn y dderbynfa.',
    'kiosk.update.short': 'Angen diweddariad',
    'kiosk.error.required': 'Atebwch y cwestiwn hwn, os gwelwch yn dda.',
    'kiosk.error.mustAcknowledge': 'Ticiwch i gadarnhau, os gwelwch yn dda.',
    'kiosk.error.nameRequired': 'Teipiwch eich enw, os gwelwch yn dda.',
    'kiosk.error.fullName': 'Rhowch eich enw cyntaf a’ch cyfenw.',
    'kiosk.error.tooLong': 'Mae’r ateb hwnnw’n rhy hir.',
    'kiosk.error.number': 'Rhowch rif, os gwelwch yn dda.',
    'kiosk.error.wholeNumber': 'Rhowch rif cyfan, os gwelwch yn dda.',
    'kiosk.error.range': 'Mae’r rhif hwnnw y tu allan i’r ystod a ganiateir.',
    'kiosk.error.email': 'Rhowch gyfeiriad e-bost dilys, os gwelwch yn dda.',
    'kiosk.error.phone': 'Rhowch rif ffôn dilys, os gwelwch yn dda.',
    'kiosk.error.date': 'Rhowch ddyddiad fel 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Mae’r ateb hwnnw’n golygu na allwch gofrestru yma. Siaradwch â’r dderbynfa, os gwelwch yn dda.',
    'kiosk.print.state.ready': 'Mae’r argraffydd yn barod',
    'kiosk.print.state.no_media': 'Mae’r argraffydd wedi rhedeg allan o labeli',
    'kiosk.print.state.cover_open': 'Mae clawr yr argraffydd yn agored',
    'kiosk.print.state.media_mismatch': 'Mae’r labeli anghywir wedi’u llwytho yn yr argraffydd',
    'kiosk.print.state.busy': 'Mae’r argraffydd yn brysur',
    'kiosk.print.state.error': 'Mae’r argraffydd wedi nodi problem',
    'kiosk.print.state.unreachable': 'Ni ellir cyrraedd yr argraffydd',
    'kiosk.print.state.unknown': 'Nid yw statws yr argraffydd yn hysbys',
    'kiosk.home.expected': 'Rwy’n cael fy nisgwyl',
    'kiosk.home.scanCode': 'Sganio fy nghod QR',
    'kiosk.scan.titleCode': 'Sganiwch eich cod QR',
    'kiosk.scan.hintCode': 'Daliwch y cod QR o’ch e-bost, eich cerdyn neu’ch bathodyn o flaen y camera.',
    'kiosk.scan.invalid': 'Nid yw’r cod QR hwnnw’n ddilys yma. Rhowch gynnig arall arni neu dewiswch eich enw o’r rhestr.',
    'kiosk.scan.notSupported': 'Ni all y ciosg hwn ddefnyddio’r math hwnnw o god QR. Dewiswch eich enw o’r rhestr.',
    'kiosk.scan.unknownMember': 'Nid yw’r cod QR hwnnw’n cael ei adnabod yn y ciosg hwn. Dewiswch eich enw o’r rhestr.',
    'kiosk.scan.oldCode': 'Mae’r cod QR hwnnw wedi cael ei ddisodli gan un newydd. Defnyddiwch yr un diweddaraf neu dewiswch eich enw.',
    'kiosk.scan.notHere': 'Nid yw’r cod QR hwnnw ar gyfer y ciosg hwn.',
    'kiosk.scan.notExpected': 'Nid ydym yn disgwyl y cod QR hwnnw heddiw. Gofynnwch yn y dderbynfa.',
    'kiosk.scan.cancelled': 'Mae’r ymweliad hwnnw wedi’i ganslo. Gofynnwch yn y dderbynfa.',
    'kiosk.scan.alreadyArrived': 'Mae’r cod QR hwnnw eisoes wedi’i ddefnyddio i gofrestru.',
    'kiosk.scan.expired': 'Mae’r cod QR hwnnw wedi dod i ben. Gofynnwch yn y dderbynfa.',
    'kiosk.expected.title': 'Pwy ydych chi?',
    'kiosk.expected.search': 'Dechreuwch deipio’ch enw',
    'kiosk.expected.exactHint': 'Teipiwch eich enw llawn yn union fel y’i rhoddwyd i ni.',
    'kiosk.expected.requiredHint': 'Mae angen eich bod yn cael eich disgwyl i gofrestru yma. Dewch o hyd i’ch enw neu sganiwch eich cod QR.',
    'kiosk.expected.none': 'Ni allem ddod o hyd i’r enw hwnnw ar restr heddiw. Gofynnwch yn y dderbynfa.',
    'kiosk.expected.empty': 'Nid oes neb yn cael ei ddisgwyl ar hyn o bryd.',
    'kiosk.expected.visiting': 'Yn ymweld â {host}',
    'kiosk.expected.required': 'Mae angen eich bod yn cael eich disgwyl i gofrestru yma. Gofynnwch yn y dderbynfa.',
    'kiosk.signout.outMark': 'Allan',
    'kiosk.signout.outToday': 'Wedi cofrestru’r ymadawiad heddiw',
    'kiosk.hostReply.on_my_way': 'Mae {host} ar y ffordd.',
    'kiosk.hostReply.please_wait': 'Mae {host} yn gofyn i chi aros, os gwelwch yn dda.',
    'kiosk.hostReply.someone': 'Eich gwesteiwr',
    'kiosk.hostReply.dismiss': 'Iawn',
    'kiosk.evacuation.notAllowed': 'Ni ellir cychwyn gwagio o’r ciosg hwn.',
    'kiosk.evacuation.wrongPin': 'Nid yw’r PIN hwnnw’n gywir.',
    'kiosk.evacuation.pinLocked': 'Gormod o PINau anghywir. Arhoswch ychydig funudau, os gwelwch yn dda.',
    'kiosk.evacuation.startFailed': 'Ni ellid cychwyn y gwagio. Rhowch gynnig arall arni.',
    'kiosk.nfc.enrolOffline': 'Mae’r ciosg hwn all-lein. Dim ond pan fydd ar-lein y gellir cofrestru cardiau.',
    'kiosk.nfc.enrolExpired': 'Mae’r gofrestriad cerdyn hwn wedi gorffen neu wedi dod i ben.',
    'kiosk.nfc.enrolFailed': 'Ni ellid cofrestru’r cerdyn hwnnw. Rhowch gynnig ar un arall.',
    'kiosk.nfc.enrolTapAgain': 'Tapiwch y cerdyn eto, os gwelwch yn dda.',
    'kiosk.common.ok': 'Iawn',
    'kiosk.welcome.stale': 'Mae’r ciosg hwn wedi bod all-lein ers amser hir. Dywedwch wrth y dderbynfa, os gwelwch yn dda.',
    'kiosk.welcome.busy': 'Mae’r safle’n brysur ar hyn o bryd. Os ydych yn ymweld, dywedwch wrth y dderbynfa, os gwelwch yn dda.',
    'kiosk.welcome.evacuation': 'Gwagio',
    'kiosk.home.delivery': 'Rwy’n danfon parsel',
    'kiosk.check.seeReceptionTitle': 'Ewch at y dderbynfa, os gwelwch yn dda',
    'kiosk.check.warnTitle': 'Cyn i chi barhau',
    'kiosk.full.short': 'Mae’r safle’n llawn',
    'kiosk.full.title': 'Mae’r safle’n llawn',
    'kiosk.full.message': 'Ni allwn gofrestru mwy o ymwelwyr ar hyn o bryd. Ewch at y dderbynfa, os gwelwch yn dda.',
    'kiosk.induction.subtitle': 'Sefydlu ar y safle',
    'kiosk.induction.unavailable': 'Nid yw’r sefydlu ar gael ar y ciosg hwn. Ewch at y dderbynfa, os gwelwch yn dda.',
    'kiosk.induction.videoMissing': 'Nid yw’r fideo ar y ciosg eto. Darllenwch y testun isod, os gwelwch yn dda.',
    'kiosk.induction.pdfNote': 'Darllenwch y testun sefydlu isod, os gwelwch yn dda. Gofynnwch i’r dderbynfa os hoffech y ddogfen.',
    'kiosk.induction.wait': 'Arhoswch {seconds} eiliad, os gwelwch yn dda',
    'kiosk.induction.startQuiz': 'Dechrau’r cwestiynau',
    'kiosk.induction.question': 'Cwestiwn {n} o {total}',
    'kiosk.induction.chooseMany': 'Dewiswch bob ateb cywir.',
    'kiosk.induction.finish': 'Gorffen',
    'kiosk.induction.retryTitle': 'Dim eto',
    'kiosk.induction.retryMessage': 'Nid oedd rhai atebion yn gywir. Rhowch gynnig arall ar {count}.',
    'kiosk.induction.retryButton': 'Rhowch gynnig arall arni',
    'kiosk.permits.title': 'Eich trwyddedau gwaith',
    'kiosk.permits.unavailable': 'Ni ellir dangos eich trwyddedau ar hyn o bryd. Ewch at y dderbynfa cyn i chi ddechrau gweithio.',
    'kiosk.permits.allAccepted': 'Rydych wedi derbyn eich holl drwyddedau.',
    'kiosk.permits.progress': 'Trwydded {n} o {total}',
    'kiosk.permits.valid': 'O {from} hyd {until}',
    'kiosk.permits.conditions': 'Amodau',
    'kiosk.permits.precautions': 'Rhagofalon',
    'kiosk.permits.signHere': 'Llofnodwch yma i dderbyn, {name}',
    'kiosk.permits.accept': 'Rwy’n derbyn y drwydded hon',
    'kiosk.nfc.blocked': 'Mae’r cerdyn hwn wedi cael ei rwystro',
    'kiosk.nfc.unknown': 'Ni adnabuwyd y cerdyn',
    'kiosk.nfc.enrolTitle': 'Cofrestru cardiau',
    'kiosk.nfc.enrolProgress': '{done} o {total} wedi’u gwneud',
    'kiosk.nfc.enrolTapFor': 'Tapiwch y cerdyn ar gyfer',
    'kiosk.nfc.enrolHold': 'Daliwch y cerdyn yn erbyn cefn y dabled.',
    'kiosk.nfc.enrolSaving': 'Yn cadw…',
    'kiosk.nfc.enrolOk': 'Cerdyn wedi’i gadw.',
    'kiosk.nfc.enrolDone': 'Mae’r holl gardiau wedi’u cofrestru',
    'kiosk.nfc.noReader': 'Nid oes darllenydd cardiau wedi’i droi ymlaen yn y ciosg hwn.',
    'kiosk.evacuation.title': 'GWAGIO',
    'kiosk.evacuation.drillTitle': 'DRILIAU TÂN',
    'kiosk.evacuation.startTitle': 'Dechrau gwagio',
    'kiosk.evacuation.confirmTitle': 'Dechrau gwagio?',
    'kiosk.evacuation.confirmMessage': 'Mae hyn yn rhybuddio pawb ar y safle ac yn agor y rhestr alw.',
    'kiosk.evacuation.confirmStart': 'Dechrau’r gwagio',
    'kiosk.evacuation.leave': 'Gadael y rhestr alw',
    'kiosk.evacuation.leaveTitle': 'Rhowch y PIN i adael y rhestr alw',
    'kiosk.evacuation.returnBanner': 'Gwagio ar y gweill. Tapiwch i fynd yn ôl at y rhestr alw.',
    'kiosk.evacuation.offline': 'All-lein: cedwir eich nodiadau a’u hanfon pan ddaw’r rhwydwaith yn ôl.',
    'kiosk.evacuation.localOnly': 'Wedi’i ddechrau ar y ciosg hwn tra’n all-lein. Bydd yn cael ei uno â’r porth pan ddaw’r rhwydwaith yn ôl.',
    'kiosk.evacuation.countUnaccounted': 'Heb ei ganfod eto',
    'kiosk.evacuation.countSafe': 'Yn ddiogel',
    'kiosk.evacuation.countMissing': 'Ar goll',
    'kiosk.evacuation.countTotal': 'Ar y safle',
    'kiosk.evacuation.allPoints': 'Pawb',
    'kiosk.evacuation.search': 'Chwilio yn ôl enw',
    'kiosk.evacuation.onlyOpen': 'Heb fod yn ddiogel eto',
    'kiosk.evacuation.loading': 'Yn llwytho’r rhestr alw…',
    'kiosk.evacuation.nobody': 'Does neb i’w ddangos.',
    'kiosk.evacuation.safe': 'Yn ddiogel',
    'kiosk.evacuation.markedSafe': 'YN DDIOGEL (tapiwch i ddadwneud)',
    'kiosk.evacuation.missing': 'Ar goll',
    'kiosk.evacuation.markedMissing': 'AR GOLL (tapiwch i ddadwneud)',
    'kiosk.evacuation.host': 'Gwesteiwr: {name}',
    'kiosk.evacuation.check': 'GWIRIO',
    'kiosk.evacuation.permits': '{count} trwydded/trwyddedau agored',
    'kiosk.contactless.qrLabel': 'Sganiwch y cod hwn gyda’ch ffôn i gofrestru',
    'kiosk.contactless.scanMe': 'Cofrestrwch gyda’ch ffôn',
    'kiosk.courier.whoTitle': 'Ar gyfer pwy mae’r parsel?',
    'kiosk.courier.whoHint': 'Teipiwch ychydig o lythrennau o’u henw.',
    'kiosk.courier.search': 'Enw’r person',
    'kiosk.courier.useName': 'Defnyddio “{name}”',
    'kiosk.courier.useNameHint': 'Bydd y dderbynfa’n ei drosglwyddo',
    'kiosk.courier.carrierTitle': 'O ba gwmni rydych chi?',
    'kiosk.courier.forName': 'Parsel i {name}',
    'kiosk.courier.other': 'Arall',
    'kiosk.courier.otherLabel': 'Enw’r cwmni',
    'kiosk.courier.countTitle': 'Faint o barseli?',
    'kiosk.courier.howMany': 'Nifer y parseli',
    'kiosk.courier.save': 'Wedi gorffen',
    'kiosk.courier.thanks': 'Diolch',
    'kiosk.courier.thanksMessage': 'Rydym wedi dweud wrthynt fod eu parsel yma.',
    'kiosk.support.pinTitle': 'Cymorth: rhowch y PIN',
    'kiosk.support.title': 'Cymorth',
    'kiosk.support.close': 'Cau',
    'kiosk.support.network': 'Rhwydwaith',
    'kiosk.support.online': 'Ar-lein',
    'kiosk.support.offline': 'All-lein',
    'kiosk.support.queue': 'Yn aros i gael ei anfon',
    'kiosk.support.oldest': 'Yr hynaf yn aros ers',
    'kiosk.support.none': 'Dim',
    'kiosk.support.deadLetters': 'Wedi’u gwrthod gan y gweinydd (heb eu hanfon)',
    'kiosk.support.deadHelp': 'Mae’r eitemau hyn wedi cael eu gwrthod gan y gweinydd ac maent yn aros ar y ciosg hwn. Dywedwch wrth eich gweinyddwr; mae tudalen y ddyfais yn y porth yn dangos y nifer.',
    'kiosk.support.configAge': 'Gosodiadau wedi’u diweddaru ddiwethaf',
    'kiosk.support.ageUnknown': 'Byth',
    'kiosk.support.ageMinutes': '{n} munud yn ôl',
    'kiosk.support.ageHours': '{n} awr yn ôl',
    'kiosk.support.ageDays': '{n} diwrnod yn ôl',
    'kiosk.support.nfc': 'Darllenydd cardiau',
    'kiosk.support.nfcReady': 'Yn barod',
    'kiosk.support.nfcOff': 'Wedi’i ddiffodd',
    'kiosk.support.nfcNone': 'Heb ei osod',
    'kiosk.support.media': 'Fideos wedi’u storio',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Pobl ar y safle (y ciosg hwn)',
    'kiosk.finish.poweredBy': 'Wedi’i bweru gan CloudSign',
    'kiosk.badge.noMedia': 'Mae’r argraffydd bathodynnau wedi rhedeg allan o labeli. Rydych wedi cofrestru. Dywedwch wrth y dderbynfa, os gwelwch yn dda.',
    'kiosk.badge.mediaMismatch': 'Mae’r labeli anghywir wedi’u llwytho yn yr argraffydd bathodynnau. Rydych wedi cofrestru. Dywedwch wrth y dderbynfa, os gwelwch yn dda.',
    'kiosk.badge.coverOpen': 'Mae clawr yr argraffydd bathodynnau yn agored. Rydych wedi cofrestru. Dywedwch wrth y dderbynfa, os gwelwch yn dda.',
    'kiosk.member.menuTitle': 'Beth hoffech chi ei wneud?',
    'kiosk.member.signIn': 'Cofrestrwch fi',
    'kiosk.member.updatePhoto': 'Diweddaru fy llun',
    'kiosk.member.sendInvite': 'Anfonwch wahoddiad ap ataf',
    'kiosk.memberPhoto.title': 'Diweddarwch eich llun',
    'kiosk.memberPhoto.saved': 'Mae eich llun wedi’i ddiweddaru.',
    'kiosk.memberPhoto.failed': 'Ni ellid cadw eich llun. Rhowch gynnig arall arni neu gofynnwch yn y dderbynfa.',
    'kiosk.memberPhoto.offline': 'Mae’r ciosg hwn all-lein, felly ni ellir diweddaru eich llun ar hyn o bryd.',
    'kiosk.memberPhoto.notAllowed': 'Ni ellir diweddaru eich llun yn y ciosg. Gofynnwch yn y dderbynfa.',
    'kiosk.invite.title': 'Cael ap CloudSign',
    'kiosk.invite.sent': 'Rydym wedi anfon dolen atoch drwy e-bost i sefydlu’r ap. Gwiriwch eich mewnflwch.',
    'kiosk.invite.noEmail': 'Nid oes gennym gyfeiriad e-bost ar eich cyfer, felly ni allem anfon gwahoddiad. Gofynnwch yn y dderbynfa.',
    'kiosk.invite.tooMany': 'Rydych wedi gofyn am ormod o wahoddiadau heddiw. Rhowch gynnig arall arni yfory.',
    'kiosk.invite.failed': 'Ni ellid anfon y gwahoddiad. Rhowch gynnig arall arni neu gofynnwch yn y dderbynfa.',
    'kiosk.invite.offline': 'Mae’r ciosg hwn all-lein, felly ni ellir anfon gwahoddiad ar hyn o bryd.',
    'kiosk.invite.sending': 'Yn anfon eich gwahoddiad…',
    'kiosk.language.choose': 'Dewiswch eich iaith',
    'kiosk.language.button': 'Iaith',
    'public.language.label': 'Iaith',
    'contactless.thank_you': 'Diolch. Rydych wedi cofrestru.',
    'contactless.thank_you_out': 'Diolch. Rydych wedi cofrestru’ch ymadawiad.',
    'contactless.poster.title': 'Sganiwch i gofrestru',
    'contactless.poster.hint': 'Pwyntiwch gamera eich ffôn at y cod. Nid oes angen ap.',
    'check.safety_check.refused': 'Ewch at y dderbynfa cyn cofrestru.',
    'check.safety_check.alert': 'Caniatawyd mynediad gyda rhybudd i’r dderbynfa (gwiriad diogelwch).',
    'check.compliance.refused': 'Mae dogfen ofynnol ar goll neu wedi dod i ben. Ewch at y dderbynfa, os gwelwch yn dda.',
    'check.compliance.warned': 'Mae dogfen ofynnol ar goll neu wedi dod i ben.',
    'check.induction.required': 'Cwblhewch y sefydlu ar y safle yn gyntaf, os gwelwch yn dda.',
    'check.capacity.full': 'Mae’r safle’n llawn ar hyn o bryd. Ewch at y dderbynfa, os gwelwch yn dda.',
    'check.capacity.warned': 'Cofrestrwyd tra oedd y safle dros ei gapasiti.',
    'check.offline': 'Cofnodwyd tra oedd y ciosg all-lein.',
};
//# sourceMappingURL=cy.js.map